import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AppProvider } from "./context/context";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/authContex";
import { GoogleOAuthProvider } from "@react-oauth/google";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppProvider>
      <BrowserRouter>
        <AuthProvider>
          <GoogleOAuthProvider clientId="893695687622-stat91ikrjh25f9kotsdjq7to8gthcb9.apps.googleusercontent.com">
            <App />
          </GoogleOAuthProvider>
        </AuthProvider>
      </BrowserRouter>
    </AppProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
